import axios from 'axios';
 

export const getsolutions = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}solutions`); 
    return response.data;
  } catch (error) {
    console.error('Error fetching menu:', error);
    throw error;
  }
};
